/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CompetenceCategory } from '../model/competenceCategory';
import { CompetenceCategoryLookup } from '../model/competenceCategoryLookup';
import { CompetenceDetail } from '../model/competenceDetail';
import { CompetenceLookup } from '../model/competenceLookup';
import { PaginatedCompetenceCategoryList } from '../model/paginatedCompetenceCategoryList';
import { PaginatedCompetenceListList } from '../model/paginatedCompetenceListList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioCompetenciesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param childUuid UUID of the child
     * @param groupUuid UUID of the group
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param touchesDateFrom 
     * @param touchesDateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioCompetenceCategoriesList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedCompetenceCategoryList>;
    public childPortfolioCompetenceCategoriesList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedCompetenceCategoryList>>;
    public childPortfolioCompetenceCategoriesList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedCompetenceCategoryList>>;
    public childPortfolioCompetenceCategoriesList(childUuid?: Array<string>, groupUuid?: string, limit?: number, offset?: number, touchesDateFrom?: string, touchesDateTo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (touchesDateFrom !== undefined && touchesDateFrom !== null) {
            queryParameters = queryParameters.set('touches_date_from', <any>touchesDateFrom);
        }
        if (touchesDateTo !== undefined && touchesDateTo !== null) {
            queryParameters = queryParameters.set('touches_date_to', <any>touchesDateTo);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedCompetenceCategoryList>('get',`${this.basePath}/child-portfolio/competence-categories/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lookup endpoint for competence categories.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioCompetenceCategoriesLookupList(observe?: 'body', reportProgress?: boolean): Observable<Array<CompetenceCategoryLookup>>;
    public childPortfolioCompetenceCategoriesLookupList(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CompetenceCategoryLookup>>>;
    public childPortfolioCompetenceCategoriesLookupList(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CompetenceCategoryLookup>>>;
    public childPortfolioCompetenceCategoriesLookupList(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CompetenceCategoryLookup>>('get',`${this.basePath}/child-portfolio/competence-categories/lookup/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param id A unique integer value identifying this tag.
     * @param childUuid UUID of the child
     * @param groupUuid UUID of the group
     * @param touchesDateFrom 
     * @param touchesDateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioCompetenceCategoriesRetrieve(id: number, childUuid?: Array<string>, groupUuid?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'body', reportProgress?: boolean): Observable<CompetenceCategory>;
    public childPortfolioCompetenceCategoriesRetrieve(id: number, childUuid?: Array<string>, groupUuid?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CompetenceCategory>>;
    public childPortfolioCompetenceCategoriesRetrieve(id: number, childUuid?: Array<string>, groupUuid?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CompetenceCategory>>;
    public childPortfolioCompetenceCategoriesRetrieve(id: number, childUuid?: Array<string>, groupUuid?: string, touchesDateFrom?: string, touchesDateTo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioCompetenceCategoriesRetrieve.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (touchesDateFrom !== undefined && touchesDateFrom !== null) {
            queryParameters = queryParameters.set('touches_date_from', <any>touchesDateFrom);
        }
        if (touchesDateTo !== undefined && touchesDateTo !== null) {
            queryParameters = queryParameters.set('touches_date_to', <any>touchesDateTo);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CompetenceCategory>('get',`${this.basePath}/child-portfolio/competence-categories/${encodeURIComponent(String(id))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param categoryUuid 
     * @param categoryUuids Více hodnot lze oddělit čárkami.
     * @param childUuid UUID of the child
     * @param excludeNoTouches No Touches
     * @param groupUuid UUID of the group
     * @param isWatched 
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param touchesDateFrom 
     * @param touchesDateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioCompetenciesList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedCompetenceListList>;
    public childPortfolioCompetenciesList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedCompetenceListList>>;
    public childPortfolioCompetenciesList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedCompetenceListList>>;
    public childPortfolioCompetenciesList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, touchesDateFrom?: string, touchesDateTo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {













        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (categoryUuid !== undefined && categoryUuid !== null) {
            queryParameters = queryParameters.set('category__uuid', <any>categoryUuid);
        }
        if (categoryUuids) {
            queryParameters = queryParameters.set('category_uuids', categoryUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (excludeNoTouches !== undefined && excludeNoTouches !== null) {
            queryParameters = queryParameters.set('exclude_no_touches', <any>excludeNoTouches);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isWatched !== undefined && isWatched !== null) {
            queryParameters = queryParameters.set('is_watched', <any>isWatched);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (touchesDateFrom !== undefined && touchesDateFrom !== null) {
            queryParameters = queryParameters.set('touches_date_from', <any>touchesDateFrom);
        }
        if (touchesDateTo !== undefined && touchesDateTo !== null) {
            queryParameters = queryParameters.set('touches_date_to', <any>touchesDateTo);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedCompetenceListList>('get',`${this.basePath}/child-portfolio/competencies/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param categoryUuid 
     * @param categoryUuids Více hodnot lze oddělit čárkami.
     * @param childUuid UUID of the child
     * @param excludeNoTouches No Touches
     * @param groupUuid UUID of the group
     * @param isWatched 
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioCompetenciesLookupList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CompetenceLookup>>;
    public childPortfolioCompetenciesLookupList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CompetenceLookup>>>;
    public childPortfolioCompetenciesLookupList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CompetenceLookup>>>;
    public childPortfolioCompetenciesLookupList(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (categoryUuid !== undefined && categoryUuid !== null) {
            queryParameters = queryParameters.set('category__uuid', <any>categoryUuid);
        }
        if (categoryUuids) {
            queryParameters = queryParameters.set('category_uuids', categoryUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (excludeNoTouches !== undefined && excludeNoTouches !== null) {
            queryParameters = queryParameters.set('exclude_no_touches', <any>excludeNoTouches);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isWatched !== undefined && isWatched !== null) {
            queryParameters = queryParameters.set('is_watched', <any>isWatched);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CompetenceLookup>>('get',`${this.basePath}/child-portfolio/competencies/lookup/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Return all competences for child or group as Excel file.
     * @param categoryUuid 
     * @param categoryUuids Více hodnot lze oddělit čárkami.
     * @param childUuid UUID of the child
     * @param excludeNoTouches No Touches
     * @param groupUuid UUID of the group
     * @param isWatched 
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param type Export type: &#x27;csv&#x27; or &#x27;xlsx&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioCompetenciesPrintRetrieve(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, type?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public childPortfolioCompetenciesPrintRetrieve(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public childPortfolioCompetenciesPrintRetrieve(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public childPortfolioCompetenciesPrintRetrieve(categoryUuid?: string, categoryUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, groupUuid?: string, isWatched?: boolean, ordering?: string, search?: string, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (categoryUuid !== undefined && categoryUuid !== null) {
            queryParameters = queryParameters.set('category__uuid', <any>categoryUuid);
        }
        if (categoryUuids) {
            queryParameters = queryParameters.set('category_uuids', categoryUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (excludeNoTouches !== undefined && excludeNoTouches !== null) {
            queryParameters = queryParameters.set('exclude_no_touches', <any>excludeNoTouches);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isWatched !== undefined && isWatched !== null) {
            queryParameters = queryParameters.set('is_watched', <any>isWatched);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/child-portfolio/competencies/print/`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param id A UUID string identifying this Kompetence.
     * @param childUuid UUID of the child
     * @param groupUuid UUID of the group
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioCompetenciesRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<CompetenceDetail>;
    public childPortfolioCompetenciesRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CompetenceDetail>>;
    public childPortfolioCompetenciesRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CompetenceDetail>>;
    public childPortfolioCompetenciesRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioCompetenciesRetrieve.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CompetenceDetail>('get',`${this.basePath}/child-portfolio/competencies/${encodeURIComponent(String(id))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
